import { Radar } from '@orgus/ui/icons';
import { CheckSettings } from '../../project-health/CheckSettings.tsx';
import type { SettingsSection } from '../registry.ts';

/** The thresholds of the checks Orgus runs on every project (project protocol, R-PP-3). */
const section: SettingsSection = {
  id: 'problem-checks',
  title: 'Problem checks',
  description: 'When Orgus raises a problem, and whether it fixes it on its own.',
  order: 30,
  group: 'alerts',
  keywords: ['problems', 'thresholds', 'health', 'cpu', 'stalled', 'waiting', 'worktree', 'native checks'],
  icon: Radar,
  Component: CheckSettings,
  needs: { module: 'project-protocol', feature: 'Problem checks', plural: true, instead: 'Sessions, machines and approvals still show their live state.' },
};
export default section;
